<mat-card-header>
  <mat-card-title>{{ data.message }}</mat-card-title>
</mat-card-header>

<mat-card-content class="padding all card-content">
  <div class="wrapper">
    <div class="row">
      <div class="col">
        <div class="row">
          Please confirm your reason to change/delete the {{ data.source }} below by completing the fields.
        </div>
      </div>
    </div>

    <!-- Confirm Form -->
    <form [formGroup]="confirmForm" autocompete="off" (keyup.enter)="confirmSelected()">
      <div class="section margin top lg">
        <!-- Reason -->
        <div class="row margin bottom">
          <div class="margin sm right bottom">
            <div class="row">
              <h4 class="bold">Action Date</h4>
            </div>
            <div class="row">
              <span>{{ currentDate | date : 'longDate' }}</span>
            </div>
          </div>

          <!-- City -->
          <div class="margin sm left right bottom">
            <div class="row label">
              <h4 class="bold">Action Type</h4>
            </div>
            <div class="row">
              <span>{{ data.actionType }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <mat-form-field appearance="outline" class="fill action-description" floatLabel="always">
            <mat-label>Action Description</mat-label>
            <input type="text" matInput [matAutocomplete]="auto" formControlName="reason" placeholder="Select state" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let reason of filteredReasons | async" [value]="reason">
                {{ reason }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="fill" floatLabel="always">
            <mat-label>Details</mat-label>
            <input
              id="details"
              placeholder="Enter Reason for action"
              formControlName="details"
              (focus)="focusOn('details')"
              (focusout)="focusOn('details')"
              autocomplete="no"
              cdkFocusInitial
              matInput
              aria-describedby="details for action"
              maxlength="500"
            />
            <mat-hint align="end">{{ confirmForm.controls['details'].value.length }} / 500</mat-hint>
          </mat-form-field>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.reason">
            <div
              class="caption error-message"
              *ngIf="fieldHasErrorMessages(confirmForm, validation, 'reason')"
              id="reasonErrors"
            >
              {{ validation.message }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</mat-card-content>

<mat-card-actions>
  <div class="row flex-end">
    <button id="btn-cancel" mat-flat-button class="margin left" *ngIf="data.showCancel" (click)="cancelSelected()">
      {{ data.cancel }}
    </button>

    <button
      mat-flat-button
      id="btn-confirm"
      class="margin left"
      [color]="'#393E46'"
      (click)="confirmSelected()"
      [disabled]="!confirmForm.valid && data.reasonRequired"
    >
      {{ data.confirm }}
    </button>
  </div>
</mat-card-actions>
